<template>
  <div class="container px-5 pt-2 mx-auto">
    <div class="text-center mb-20">
      <h1
        class="sm:text-3xl text-2xl font-medium title-font text-indigo-500 mb-4 uppercase tracking-widest"
        v-html="this.sectionTitle"
      ></h1>
      <p
        class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto"
        v-html="this.sectionSubTitle"
      ></p>
      <div class="flex mt-6 justify-center">
        <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    sectionTitle: String,
    sectionSubTitle: String
  },
  //   components: { GenQrCode },
  data: () => ({
    //
  })
};
</script>

<style></style>
